export default __webpack_public_path__ + "static/berlin-935960_1920-eb031b3586a3771b135676317acf46be.png";